export default {
  name: "IndexView",
  components: {},
  data() {
    return {};
  },
  methods: {
    init() {}
  },
  mounted() {
    this.init();
  }
};